module.exports = __webpack_public_path__ + "static/media/collections.a3030d04.svg";